/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { useStore } from '@thd-nucleus/experience-context';
import { useDraftOmsId, usePlaConfigurationsParams, useStoreIdZipcodeParams } from './hooks';
import { fetchPageData } from '../app/utils/fetchPageData';
import { setPageData } from './setPageData';
import { setConfig } from '../app/actions/configActions';
import { getPlaConfigurationDetails } from '../app/api/plaConfigurationApi';
import { setPlaConfigurationDetails } from '../app/actions/plaConfigurations';
import isStoreEnabled from '../app/utils/isStoreEnabled';
import { setHeaderStoreChanged } from '../app/actions/store';
import {
  forcePlaExitIfOutOfRegion,
  plaConfigurationDetailsFormatter,
  plaDetailPriceResponseFormatter,
  findPlaColor,
  findPlaSquareFeet
} from '../app/utils/plaConfigurationUtils';
import { Utils, POST_FORM_TESTING_PARAM } from '../app/utils/urlUtils';
import { SET_LAMINATE_POST_FORM_FEATURE_GATE } from '../app/actions/actionTypes';

export const Pcp = ({ history, store }) => {
  const [pcp, setPcpComponent] = useState(null);
  const { storeId, storeZip } = useStore();
  const { paramStoreId, paramZipcode } = useStoreIdZipcodeParams();
  const { omsId } = useDraftOmsId();
  const { configurationIdForSelections, plaGuid, regionId } = usePlaConfigurationsParams();
  const { plaConfiguration } = store.getState();
  const windowAvailable = typeof window !== 'undefined' ? window : null;
  const [injectedConfiguratorAvailable, setInjectedConfiguratorAvailable] = useState(false);
  const [surfaceCodes, setSurfaceCodes] = useState(null);
  const [url, setUrl] = useState(null);

  const loadPlaConfigurationDetails = async () => {
    let plaConfigurationDetails = await getPlaConfigurationDetails(
      plaGuid,
      configurationIdForSelections,
      omsId,
      regionId,
      surfaceCodes);
    const invalidConfigurationsStructure = Array.isArray(plaConfigurationDetails.configurations);
    if (invalidConfigurationsStructure) {
      plaConfigurationDetails = plaConfigurationDetailsFormatter(plaConfigurationDetails);
    }
    const { storeNumbers } = plaConfigurationDetails;
    const plaColor = findPlaColor(plaConfigurationDetails);
    const plaSquareFootage = findPlaSquareFeet(plaConfigurationDetails);
    const plaConfiguredPrice = plaDetailPriceResponseFormatter(plaConfigurationDetails.configuration.price);

    if (storeNumbers.includes(storeId.toString())) {
      store.dispatch(setPlaConfigurationDetails({ plaConfigurationDetails, plaColor, plaConfiguredPrice, plaSquareFootage }));
    } else {
      forcePlaExitIfOutOfRegion(
        regionId,
        storeId,
        null,
        plaGuid,
        configurationIdForSelections,
        storeNumbers,
        store.dispatch,
        null
      );
    }
  };

  useEffect(() => {
    if (windowAvailable) {
      if (windowAvailable?.injectedConfiguratorSettings && !injectedConfiguratorAvailable) {
        setInjectedConfiguratorAvailable(!!windowAvailable?.injectedConfiguratorSettings);
      }

      if (windowAvailable?.injectedConfiguratorSettings && !surfaceCodes) {
        setSurfaceCodes(
        windowAvailable?.injectedConfiguratorSettings?.attributes['external IDs (multiple)']
        );
      }

      if (windowAvailable?.injectedConfiguratorSettings) {
        const laminatePostFormFeatureGate = windowAvailable?.injectedConfiguratorSettings?.laminatePostFormFeatureGate || Utils.getParameterByName(POST_FORM_TESTING_PARAM) === 'true';
        store.dispatch({
          type: SET_LAMINATE_POST_FORM_FEATURE_GATE,
          laminatePostFormFeatureGate
        });
      }

      if (windowAvailable?.location && url === null) {
        setUrl(windowAvailable?.location.href);
      }
    }
  }, [windowAvailable?.injectedConfiguratorSettings, windowAvailable?.location]);

  useEffect(() => {
    if (omsId) {
      const loadComponent = async (config) => {
        const pcpComponent = await import(/* webpackChunkName: "pcp" */ './PcpApp');
        setPcpComponent(<pcpComponent.PcpApp name="gcc-thd-pcp" history={history} config={config} />);
      };
      fetchPageData(omsId).then((pageData) => {
        store.dispatch(setConfig(pageData.settings));
        setPageData(pageData);
        if (
          !plaConfiguration?.plaConfigurationDetails?.storeNumbers
          && configurationIdForSelections
          && plaGuid
          && regionId
        ) {
          loadPlaConfigurationDetails();
        }
        loadComponent(pageData?.settings);
      }).catch();
    } else {
      // eslint-disable-next-line no-console
      console.log('productId not set.');
    }
  }, []);

  useEffect(() => {
    if (/\/countertops\/configurator\//i.test(history?.location?.pathname.toLocaleLowerCase())) {
      if (paramStoreId && paramZipcode) {
        store.dispatch(setHeaderStoreChanged({
          isStoreEnabled: isStoreEnabled(paramStoreId),
          storeId: paramStoreId,
          zipcode: paramZipcode,
        }));
      } else {
        store.dispatch(setHeaderStoreChanged({
          isStoreEnabled: isStoreEnabled(storeId),
          storeId,
          zipcode: storeZip,
        }));
      }

      if (configurationIdForSelections && plaGuid && regionId && injectedConfiguratorAvailable) {
        if (!plaConfiguration?.plaConfigurationDetails?.storeNumbers) {
          loadPlaConfigurationDetails();
        }
      }
    }
  }, [storeId]
  );

  return (
    <div className="container">
      {pcp}
    </div>
  );
};

Pcp.propTypes = {
};

Pcp.displayName = 'PcpPage';

Pcp.defaultProps = {
  name: 'gcc-thd-pcp',
};
